<template>
    <div class="flats-crm-prems">
        <div class="number-items">
            <div class="item" v-for="item in flatsArr.flats_prems" :key="item.info">
                <!-- <div class="item-num">0{{index + 1}}</div> -->
                <div class="item-title"><h3 v-html="item.title"></h3></div>
                <div class="item-desc"><p v-html="item.info"></p></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-flats-prems',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            flatsArr: 'loadApartments',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-prems.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-prems-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>